import { DISMISS, useNotification } from "collections";
import { DeleteModal, useModalDispatch } from "collections/Modal";
import { useDeleteUserGroupMutation } from "generated/graphql";
import React from "react";
import { useTranslation } from "utilities/i18n";

export const DeleteGroupsModal: React.FC<{
  tenantId: string;
  groups: Array<string>;
}> = ({ groups, tenantId }) => {
  const { t } = useTranslation();
  const [addNotification] = useNotification();
  const [, deleteGroup] = useDeleteUserGroupMutation();
  const dismiss = useModalDispatch();

  const deleteUserGroups = async () => {
    let responses = [];
    for (const groupId of groups) {
      const { data } = await deleteGroup({
        tenantId: tenantId,
        id: groupId
      });
      responses.push(data?.deleteUserGroup);
    }

    const numErrors = responses.filter(response => response?.error).length;

    if (numErrors === 0) {
      addNotification({
        type: "success",
        dismiss: DISMISS.DEFAULT,
        message: t("SUCCESSFULLY_DELETED", {
          entity: t("DEVICE_USER_GROUP", { count: groups.length })
        }),
        persistThroughNav: true
      });
    }
    if (numErrors > 0) {
      addNotification({
        type: "error",
        dismiss: DISMISS.DEFAULT,
        message: t("DELETE_DEVICE_USER_GROUP_FAILURE", {
          count: numErrors
        }),
        persistThroughNav: true
      });
    }
    dismiss();
  };

  return (
    <DeleteModal
      entity={t("DEVICE_USER_GROUP", { count: groups.length })}
      confirmationString={t("CONFIRM_DELETE_DEVICE_USER_GROUP", {
        count: groups.length
      })}
      onDelete={deleteUserGroups}
      name="DeleteDeviceUserGroup"
    />
  );
};
